import {
  WishlistStreamItem,
  WishlistStreamItem_Product,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wishlist/v1/page/stream.types';

type Product = {
  streamPosition: number;
  type: {
    $case: 'product';
    product: WishlistStreamItem_Product;
  };
};

export function isProduct(item: WishlistStreamItem): item is Product {
  return item.type?.$case === 'product';
}
